module.exports = __webpack_public_path__ + "img/cx_teste_covid_anticorpos.84c4ad89.webp";